import React, { useState, useEffect } from "react";
import "../styles/Loader.css"; // CSS-Datei für das Styling

const Loader = () => {
  const [loading, setLoading] = useState(true); // Zustand für das Laden

  useEffect(() => {
    // Simulierte Ladezeit von 2 Sekunden
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (!loading) return null; // Loader ausblenden, wenn das Laden abgeschlossen ist

  return (
    <div className="loader">
      <div className="spinner"></div>
      <p className="loading-text">Lädt...</p>
    </div>
  );
};

export default Loader;
